import { Button, IconButton } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { PageHeader, PageLayout } from "@zapier/design-system-beta";
import {
  isViewOnlyDowntimeOverrideAtom,
  togglesAtomResettable,
} from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import { NavToggle } from "@zapier/components";
import { usePathname } from "next/navigation";

import { ViewOnlyDowntimeBanner } from "../BuilderNav/ViewOnlyDowntimeBanner";
import { Notifications } from "../Notifications";

import styles from "./CanvasListLayout.module.css";

const links = [
  {
    id: "canvases",
    label: "Canvases",
    href: "/app/canvas",
    icon: "navCanvas",
  },
  {
    id: "systems",
    label: "Systems",
    href: "/app/canvas/systems",
    icon: "navConnectedAssetsFill",
  },
];

export function CanvasListLayout({
  children,
  title,
  handleCreateCanvas,
}: {
  children: React.ReactNode;
  title: string;
  handleCreateCanvas?: () => void;
}) {
  const currentPath = usePathname();
  const viewOnlyDowntime = useAtomValue(isViewOnlyDowntimeOverrideAtom);
  const toggles = useAtomValue(togglesAtomResettable);
  const showSystemsNav = toggles.dataPoc;

  return (
    <PageLayout>
      <Notifications />
      {viewOnlyDowntime && (
        <div className={styles.viewOnlyDowntimeBanner}>
          <ViewOnlyDowntimeBanner />
        </div>
      )}
      <PageHeader
        title={title}
        pageTag="Beta"
        actions={
          handleCreateCanvas ? (
            <Button
              iconPosition="start"
              onPress={handleCreateCanvas}
              isDisabled={viewOnlyDowntime}
            >
              <Icon name="formAdd" />
              Create canvas
            </Button>
          ) : null
        }
        compactActions={
          handleCreateCanvas ? (
            <IconButton
              aria-label="Create canvas"
              onPress={handleCreateCanvas}
              isDisabled={viewOnlyDowntime}
              name="formAdd"
            />
          ) : null
        }
        additionalContent={
          showSystemsNav ? (
            <div className={styles.navToggle}>
              <NavToggle
                links={links}
                currentPath={currentPath || "/app/canvas"}
              />
            </div>
          ) : null
        }
      />
      {children}
    </PageLayout>
  );
}
